/** @jsx jsx */
import { css } from '@emotion/core';
import { colorsPalette } from '../../../../styles/colors';

export const enquiryInput = css({
  marginBottom: 16,
  input: {
    fontSize: '16px',
  },
  span: {
    fontSize: '16px',
  },
  label: {
    fontSize: '16px',
  },
  div: {
    maxHeight: '56px',
    borderRadius: '4px',
  },
});
export const phoneNumberField = css({});
export const enquirySubmit = css({
  marginTop: 24,
});

export const msgBox = css({ padding: '15px 0px 0px' });
export const success = css({ color: colorsPalette.teal });
export const error = css({ color: colorsPalette.red });
